/**
 * WMPCM-11002 (US-20): fewer than this many matching results show the gallery as a single column;
 * this many or more show two columns. Business has not yet confirmed whether exactly 25 should be
 * single- or two-column; the spec's current reading is "25 or more" = two columns.
 */
export const CLIKART_TWO_COLUMN_MIN_RESULTS = 25

/** Gallery column count for the number of results matching the current filters. */
export function clikArtGalleryColumnCount(matchingResultCount: number): 1 | 2 {
  return matchingResultCount < CLIKART_TWO_COLUMN_MIN_RESULTS ? 1 : 2
}
